import { useMemo } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

const getAdminHubConnectorLink = ({
	orgId,
	siteId,
	environment,
}: {
	orgId?: string;
	siteId?: string;
	environment?: string;
}) => {
	if (!orgId || !siteId || !environment) {
		return undefined;
	}

	if (environment === 'PRODUCTION') {
		return `https://admin.atlassian.com/o/${orgId}/connectors?site-id=${siteId}`;
	} else if (environment === 'STAGING') {
		return `https://admin.stg.atlassian.com/o/${orgId}/connectors?site-id=${siteId}`;
	}

	return undefined;
};

export const useAdminHubConnectorLink = () => {
	const { orgId, cloudId, environment } = useSessionData();

	return useMemo(
		() => getAdminHubConnectorLink({ orgId, siteId: cloudId, environment }),
		[orgId, cloudId, environment],
	);
};
